export const servicesData = [
  {
    id: 1,
    title: "GMB Creation & Optimization",
    desc: "Comprehensive Google My Business setup and strategic optimization designed to dominate local search results and map pack rankings.",
    icon: "📍",
  },
  {
    id: 2,
    title: "Web Development & Maintenance",
    desc: "Custom-built, high-performance websites focused on user experience, speed, and conversion to establish a powerful digital presence.",
    icon: "💻",
  },
  {
    id: 3,
    title: "Advanced SEO Strategies",
    desc: "Data-driven SEO solutions for both websites and GMB profiles to ensure long-term organic visibility and sustainable business growth.",
    icon: "🔍",
  },
  {
    id: 4,
    title: "Digital Reputation Management",
    desc: "Systematic acquisition and management of high-authority reviews to build trust, improve ratings, and establish industry leadership.",
    icon: "⭐",
  },
  {
    id: 5,
    title: "Social Media Authority",
    desc: "Full-scale social media management and optimization to increase engagement, build a loyal community, and drive brand awareness.",
    icon: "📱",
  },
  {
    id: 6,
    title: "Strategic Growth Consulting",
    desc: "Tailored digital marketing blueprints designed to scale operations, maximize ROI, and outperform local competitors.",
    icon: "🚀",
  }
];